import { render, staticRenderFns } from "./LoteProducaoConsumoRacaoTabela.vue?vue&type=template&id=49951eda&"
import script from "./LoteProducaoConsumoRacaoTabela.vue?vue&type=script&lang=js&"
export * from "./LoteProducaoConsumoRacaoTabela.vue?vue&type=script&lang=js&"
import style0 from "./LoteProducaoConsumoRacaoTabela.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VFlex,VLayout})
